import {AllActivityTypes, AllActivityTypesArray} from "../../types-enums/activity";
import {getReturnAndOneWayActivity} from "../../utils/getter/activities";
import {TravelComponentsState} from "./travel-components";

/**
 * Removes a given Activity from the Travel Components State and adds the removed Activity to the deleted Activity queue
 * from which the user can undo the deletion
 */
const removeActivityFromTravelComponentsStateAndAddToQueue = (
    updatedActivities: AllActivityTypesArray,
    travelComponentsState: TravelComponentsState,
    activity: AllActivityTypes,
    index: number
) => {
    const {common: {id}} = activity
    updatedActivities = updatedActivities.filter(activity => activity.common.id !== id)
    travelComponentsState.queueForDeleteActivity[id] = {
        index: index,
        activity
    }
    return updatedActivities
}

/**
 * Removes a given Activity from the Travel Components State. Checks if the Activity is a return Activity and also deletes
 * the return Activity.
 */
export const removeActivityFromTravelComponents = (
    updatedActivities: AllActivityTypesArray,
    travelComponentsState: TravelComponentsState,
    activity: AllActivityTypes,
    index: number
) => {
    const {returnActivity, oneWayActivity} = getReturnAndOneWayActivity(activity, travelComponentsState.activities)
    if (returnActivity) updatedActivities = removeActivityFromTravelComponentsStateAndAddToQueue(updatedActivities,
        travelComponentsState,
        returnActivity,
        index)
    if (oneWayActivity) updatedActivities = removeActivityFromTravelComponentsStateAndAddToQueue(updatedActivities,
        travelComponentsState,
        oneWayActivity,
        index)
    return updatedActivities
}